/**
 * Sauna Customization Script
 * Updates the sauna iframe URL with customize_id from current page URL
 */

(function() {
  'use strict';

  /**
   * Get URL parameter by name
   * @param {string} name - Parameter name to search for
   * @returns {string|null} Parameter value or null if not found
   */
  function getUrlParameter(name) {
    const url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return results[2];
  }

  /**
   * Update the sauna iframe URL with customize_id parameter
   */
  function updateSaunaIframe() {
    const customizeId = getUrlParameter('customize_id');
    const saunaIframe = document.getElementById('sauna-house-iframe');

    if (customizeId) {
      if (saunaIframe) {
        const baseSrc = saunaIframe.getAttribute('data-base-url') || 'https://d1qgcmdnygojo8.cloudfront.net';
        let modalId = document.getElementById('sauna_house_modal_id') ? document.getElementById('sauna_house_modal_id').value : '';
        saunaIframe.src = `${baseSrc}?customize_id=${customizeId}&modal_id=${modalId}`;
      }
    } else{
      saunaIframe.src = saunaIframe.getAttribute('data-base-url') || 'https://d1qgcmdnygojo8.cloudfront.net'
    }
  }
  // Update iframe when DOM is ready
  
    document.addEventListener('DOMContentLoaded', function() {
        updateSaunaIframe();
        setupPostMessageListener();
          // If prodId is present, update the iframe to include it
    });

  /**
   * Setup postMessage listener for iframe communication
   */
  function setupPostMessageListener() {
    
    window.addEventListener('message', async function(event) {
      // Verify origin for security (optional but recommended)
      // if (event.origin !== 'https://q87swn1b-5175.inc1.devtunnels.ms/') {
      //   return;
      // }

      // Check if message type is ADD_TO_CART
      if (event.data && event.data.type === 'ADD_TO_CART') {

        let customizationData = event.data.configuration_data || {};
        let properties = {}
        // Save configuration data first
        let saveCustomizationData = event.data.save_data? event.data.save_data : null;
        if(saveCustomizationData){
          let totalPrice = saveCustomizationData?.totalPrice || 0;
          const customizeId = getUrlParameter('customize_id');
          const prodId = getUrlParameter('variantId');
          if(customizeId && prodId) {
             // Update configuration data with new customization
             await updateConfigurationData(customizeId, saveCustomizationData, totalPrice);
             
             // Instead of updating variant, create new product with updated price
             properties = await extractCartProperties(customizationData);
             properties["_customizeId"] = customizeId;
             
             const productTitle = 'Saunahaus Konfigurator';
             const productPrice = totalPrice; // Use the total price from customization
             const imageUrl = event.data.screenshot_url || 'https://vitkonwood.de/cdn/shop/products/2_2MvitkonwoodIglusauna_360x.png?v=1659951517';
             
             // Remove old cart item first
             const cartId = await getUrlParameter('itemId');
             if (cartId) {
               await removeCartItem(cartId);
             }
             
             // Create new product and add to cart
             await productCreatApi(productTitle, productPrice, properties, imageUrl);
             return true;
          } else{
            let customizeId = await saveConfigurationData(totalPrice, saveCustomizationData);
            properties = extractCartProperties(customizationData);
            properties["_customizeId"] = customizeId; // Ensure customize_id is set
            const productTitle = 'Saunahaus Konfigurator';
            const productPrice = customizationData.totalPrice || 100.00;
            const imageUrl = event.data.screenshot_url || 'https://vitkonwood.de/cdn/shop/products/2_2MvitkonwoodIglusauna_360x.png?v=1659951517'; // Default image if not provided
            
            // Create product using the data from iframe
            await createProductFromIframe(productTitle, productPrice, properties, imageUrl);
          }
        }

        // Extract properties for cart
        
        
      }

    });
  }

  /**
   * Save configuration data via API
   * @param {number} totalPrice - Total price of configuration
   * @param {Object} configurationData - Configuration data to save
   * @returns {Promise} API response promise
   */
  async function saveConfigurationData(totalPrice, configurationData) {
    const apiUrl = 'https://api.saunahaus.vitkonwood.de/saved-configurations';
    
    const payload = {
      totalPrice: totalPrice,
      configurationData: configurationData
    };

    let response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })

    let data = await response.json();
    let customizeId = data.id; // Assuming the API returns the saved configuration ID
    return customizeId;
    
  }

  async function updateConfigurationData(customizeId,customizationData, totalPrice) {
    const apiUrl = `https://api.saunahaus.vitkonwood.de/saved-configurations/${customizeId}`
    const payload = {
      totalPrice: totalPrice,
      configurationData: customizationData
    };
    return fetch(apiUrl, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok: ' + response.statusText);
      }
      return response.json();
    })
    .then(data => {
      // Optionally send success message to iframe
    })
    .catch(error => {
      console.error('Error updating configuration:', error);
      // Optionally send error message to iframe
      throw error;
    });
  }

  async function cartUpdate(cartId, variantId, properties, quantity = 1) {
    try {
      // Get current cart to understand the structure
      const currentCart = await fetch('/cart.js').then(r => r.json());
      console.log('Current cart:', currentCart);
      console.log('Cart items:', currentCart.items);
      
      let updates = {};
      let oldVariantId;
      
      // Check if cartId is a variant ID (large number) and find the item to remove
      if (cartId > 1000) { // Assume variant IDs are large numbers
        console.log('CartId appears to be a variant ID, searching for item...');
        
        // Find the item by variant ID
        const foundItem = currentCart.items.find(item => item.variant_id == cartId);
        
        if (!foundItem) {
          throw new Error(`Variant ID ${cartId} not found in cart.`);
        }
        
        oldVariantId = foundItem.variant_id;
        console.log('Found variant ID', cartId, 'in cart');
      } else {
        // cartId is a line number, get the variant ID from that line
        const lineNumber = parseInt(cartId, 10);
        
        if (isNaN(lineNumber) || lineNumber < 1 || lineNumber > currentCart.items.length) {
          throw new Error(`Invalid line number: ${lineNumber}. Cart has ${currentCart.items.length} items.`);
        }
        
        oldVariantId = currentCart.items[lineNumber - 1].variant_id;
        console.log('Using line number', lineNumber, 'with variant ID:', oldVariantId);
      }
      
      // Step 1: Remove old item by setting quantity to 0
      updates[oldVariantId] = 0;
      console.log('Will remove variant ID:', oldVariantId);
      
      // Add a small delay to ensure variant price update is reflected in Shopify's cache
      console.log('Waiting for variant price update to propagate...');
      await new Promise(resolve => setTimeout(resolve, 2000)); // 2 second delay
      
      // Step 2: Batch update to remove old item and then add new item
      await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        return response.json();
      })
      .then(data => {
        console.log('Old cart item removed successfully:', data);
        
        // Step 3: Force refresh variant data by fetching product info first
        console.log('Fetching fresh variant data before adding to cart...');
        
        return fetch(`/products/${variantId}.js?_=${Date.now()}`)
          .then(variantResponse => {
            if (variantResponse.ok) {
              return variantResponse.json();
            }
            // If variant endpoint fails, try product endpoint
            return fetch(`/variants/${variantId}.js?_=${Date.now()}`);
          })
          .then(variantData => {
            console.log('Fresh variant data:', variantData);
            
            // Step 4: Add new item with updated variant and properties
            console.log('Adding new cart item with variant ID:', variantId);
            
            const addData = {
              id: variantId, // Use new variant ID
              quantity: quantity,
              properties: properties
            };

            // Add cache-busting parameter to ensure fresh data
            const cacheBuster = Date.now();
            
            return fetch(window.Shopify.routes.root + `cart/add.js?_=${cacheBuster}`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache'
              },
              body: JSON.stringify(addData)
            });
          })
          .catch(variantError => {
            // If variant fetch fails, still try to add to cart
            console.warn('Could not fetch fresh variant data, proceeding with cart add:', variantError);
            
            const addData = {
              id: variantId,
              quantity: quantity,
              properties: properties
            };

            const cacheBuster = Date.now();
            
            return fetch(window.Shopify.routes.root + `cart/add.js?_=${cacheBuster}`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache'
              },
              body: JSON.stringify(addData)
            });
          });
      })
      .then(addResponse => {
        if (!addResponse.ok) {
          throw new Error(`Failed to add cart item: HTTP ${addResponse.status}: ${addResponse.statusText}`);
        }
        return addResponse.json();
      })
      .then(cartData => {
        console.log('New cart item added successfully:', cartData);

        // Send success message to iframe
        sendMessageToIframe({
          type: 'CART_UPDATE_SUCCESS',
          message: 'Cart updated successfully',
          cartData: cartData
        });

        // Redirect to cart page
        window.location.href = '/cart';
        
        return cartData;
      })
      .catch(error => {
        console.error("Error updating cart:", error);
        
        // Send error message to iframe
        sendMessageToIframe({
          type: 'CART_UPDATE_ERROR',
          message: 'Failed to update cart',
          error: error.message
        });
        
        throw error;
      });

    } catch (error) {
      console.error('Error updating cart:', error);
      
      // Send error message to iframe
      sendMessageToIframe({
        type: 'CART_UPDATE_ERROR',
        message: 'Failed to update cart',
        error: error.message
      });
      
      throw error;
    }
  }

  /**
   * Remove cart item by ID or line number
   * @param {string|number} cartId - Cart item ID or line number
   * @returns {Promise} Cart response promise
   */
  async function removeCartItem(cartId) {
    const currentCart = await fetch('/cart.js').then(r => r.json());

    let variantId;

    // Check if cartId is a variant ID (large number) and find the item to remove
    if (cartId > 1000) { // Assume variant IDs are large numbers
      const foundItem = currentCart.items.find(item => item.variant_id == cartId);
      if (!foundItem) {
        return;
      }
      variantId = foundItem.variant_id;
    } else {
      // cartId is a line number, get the variant ID from that line
      const lineNumber = parseInt(cartId, 10);

      if (isNaN(lineNumber) || lineNumber < 1 || lineNumber > currentCart.items.length) {
        throw new Error(`Invalid line number: ${lineNumber}. Cart has ${currentCart.items.length} items.`);
      }

      variantId = currentCart.items[lineNumber - 1].variant_id;
    }

    // Remove item by setting quantity to 0
    const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates: { [variantId]: 0 } })
    });

    if (!response.ok) {
      throw new Error(`Failed to remove cart item: HTTP ${response.status}: ${response.statusText}`);
    }

    return response.json();
  }

  async function updateProductVariant(variantId, updatedPrice) {
    const apiUrl = `https://sauna-backend.vitkonwood.de/api/shopify/variants/${variantId}`;
    const payload = {
      price: updatedPrice
    };
    return fetch(apiUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok: ' + response.statusText);
      }
      return response.json();
    })
    .then(data => {
      console.log('Variant update response:', data); // Debug log
      return data; // ← ADD THIS LINE! You were missing the return statement
    })
    .catch(error => {
      console.error('Error updating variant:', error);
      throw error; // Re-throw so the caller can handle it
    });
  }


  /**
   * Extract cart properties from customization data
   * @param {Object} customizationData - The configuration data from iframe
   * @returns {Object} Properties object for cart
   */
  function extractCartProperties(customizationData) {
    const properties = {};
    
    // Iterate through all customization options
    Object.keys(customizationData).forEach(key => {
      const option = customizationData[key];
      
      // Skip null values and totalPrice
      if (option !== null && key !== 'totalPrice') {
        // Handle MODELL specially (it has different structure)
        if (key === 'Modell' && option) {
          properties[key] = option;
        }
        // Handle regular options with optionName
        else if (option && option) {
          properties[key] = option;
        }
      }
    });
    
    return properties;
  }

  /**
   * Create product with data from iframe
   */
  function createProductFromIframe(title, price, properties, imageUrl) {
    productCreatApi(title, price, properties, imageUrl)
      .then(result => {
        // Note: No alert here since it's triggered from iframe
      })
      .catch(error => {
        console.error('Failed to create product from iframe:', error);
        // Could send error message back to iframe if needed
      });
  }

  /**
   * Create product via backend API
   * @param {string} title - Product title
   * @param {number|string} price - Product price
   * @returns {Promise} API response promise
   */
  async function productCreatApi(title,price, properties,imageUrl) {
    const apiUrl = 'https://sauna-backend.vitkonwood.de/api/shopify/products';
    
    const payload = {
      title: title,
      price: price,
      imageUrl:imageUrl,
    };

    return fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok: ' + response.statusText);
      }
      return response.json();
    })
    .then(data => {
      
      // Add product to cart after creation
      if (data && data.variants[0].id) {
        return addToCart(data.variants[0].id, 1, properties); // Add 1 quantity to cart with properties
      } else {
        throw new Error('Product ID not found in response');
      }
    })
    .then(cartData => {
      
      // Redirect to cart page
      window.location.href = '/cart';
      
      return cartData;
    })
    .catch(error => {
      console.error('Error creating product:', error);
      throw error;
    });
  }

  /**
   * Add product to Shopify cart
   * @param {string|number} productId - Product ID
   * @param {number} quantity - Quantity to add
   * @param {Object} properties - Cart line item properties
   * @returns {Promise} Cart response promise
   */
  async function addToCart(productId, quantity = 1, properties = {}) {
    const cartData = {
      id: productId,
      quantity: quantity,
      properties: properties
    };

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(cartData)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to add to cart: ' + response.statusText);
      }
      return response.json();
    })
    .then(cartResponse => {
      
      // Send success message to iframe
      sendMessageToIframe({
        type: 'CART_SUCCESS',
        message: 'Product added to cart successfully'
      });
      
      return cartResponse;
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      
      // Send error message to iframe
      sendMessageToIframe({
        type: 'CART_ERROR',
        message: 'Failed to add product to cart',
        error: error.message
      });
      
      throw error;
    });
  }

  /**
   * Send message to iframe
   * @param {Object} message - Message to send to iframe
   */
  function sendMessageToIframe(message) {
    const iframe = document.getElementById('sauna-house-iframe');
    if (iframe && iframe.contentWindow) {
      try {
        iframe.contentWindow.postMessage(message, 'https://d1qgcmdnygojo8.cloudfront.net');
        window.location.href = '/cart';
      } catch (error) {
        console.error('Error sending message to iframe:', error);
      }
    }
  }

})();